import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { UploadFilePayload } from '@/new-services/types/files'

type ApiUploadFileResponse = Promise<AxiosResponse<void>>
type ApiDeleteFileResponse = Promise<AxiosResponse<void>>

export function uploadFile(payload: UploadFilePayload): ApiUploadFileResponse {
    return http.postFormData('/dispatcher/api/file', payload)
}

export function deleteFile(uuidHash: string): ApiDeleteFileResponse {
    return http.delete(`/dispatcher/api/file/${uuidHash}`)
}

export function vacancyUploadFile(payload: FormData): Promise<AxiosResponse<{ data: { url: string }}>> {
    return http.postFormData('/vacancy/api/files/upload', payload)
}

export default {
    uploadFile,
    deleteFile,
    vacancyUploadFile,
}
